var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'main-navbar',
    'bg-primary',
    _vm.stickyTop ? 'sticky-top' : 'fixed-top',
  ]},[_c('d-navbar',{class:[
      'd-flex ',
      _vm.userLogged ? 'justify-content-end' : 'justify-content-start',
      'flex-md-nowrap',
      'p-0',
    ],attrs:{"type":"light"}},[(!_vm.userLogged)?_c('logo'):_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('navbar-toggle'),_c('navbar-nav')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }